import { openColorsSettings } from "utils/open-colors-settings"
import { useBrandColors } from "sdk/brand/queries"
import { useAddBrandColor } from "sdk/brand/mutations"

export function useSavedColors() {
  return {
    colors: useBrandColors().data,
    handleColorsEdit: openColorsSettings,
    handleColorAdd: useAddBrandColor()
  }
}
